import { useState } from 'react';
import { format } from 'date-fns';
import { useOverlayContext } from 'seagull';
import { useIoContext } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { useStoreActions } from '~/store/store-context';
export function useProposalsCsvExport() {
    const { api } = useStoreActions();
    const overlayContext = useOverlayContext();
    const { getNow, browser: { downloadCsv } } = useIoContext();
    const { t: texts } = useLocaleKeys('proposal.dashboard');
    const [exportingAll, setExportingAll] = useState(false);
    const [exportingSelected, setExportingSelected] = useState(false);
    const exportCsv = async (fetchCsv)=>{
        try {
            const csvString = await fetchCsv();
            downloadCsv(csvString, "anchor_proposals_export_".concat(format(getNow(), 'yyyy-MM-dd'), ".csv"));
        } catch (unused) {
            overlayContext.showErrorToast(texts.exportError(), 'export-proposals-csv-error');
        }
    };
    return {
        exportingAll,
        exportingSelected,
        exportAll: async ()=>{
            if (exportingAll) return;
            setExportingAll(true);
            await exportCsv(()=>api.relationship.exportAllProposalsCsv());
            setExportingAll(false);
        },
        exportSelected: async (proposalIds)=>{
            if (exportingSelected || proposalIds.length === 0) return;
            setExportingSelected(true);
            await exportCsv(()=>api.relationship.exportProposalsCsvByIds([
                    ...proposalIds
                ]));
            setExportingSelected(false);
        }
    };
}
